/* Gold-Standard PDP — gs-product.js
   Progressive enhancement: accordion, scroll reveal, subscription UI */

(function () {
  'use strict';

  /* --- Accordion --- */
  function initAccordions() {
    document.querySelectorAll('[data-gs-accordion-container]').forEach(function (container) {
      var items = container.querySelectorAll('[data-gs-accordion]');
      items.forEach(function (item) {
        var header = item.querySelector('[data-gs-accordion-header]');
        var content = item.querySelector('[data-gs-accordion-content]');
        if (!header || !content) return;

        content.style.height = header.getAttribute('aria-expanded') === 'true'
          ? content.scrollHeight + 'px'
          : '0';

        header.addEventListener('click', function () {
          var isExpanded = header.getAttribute('aria-expanded') === 'true';
          header.setAttribute('aria-expanded', String(!isExpanded));
          content.style.height = isExpanded ? '0' : content.scrollHeight + 'px';

          // Single-open: close siblings
          items.forEach(function (other) {
            if (other === item) return;
            var otherHeader = other.querySelector('[data-gs-accordion-header]');
            var otherContent = other.querySelector('[data-gs-accordion-content]');
            if (otherHeader && otherContent) {
              otherHeader.setAttribute('aria-expanded', 'false');
              otherContent.style.height = '0';
            }
          });
        });
      });
    });
  }

  /* --- Scroll Reveal --- */
  function initScrollReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.gs-reveal').forEach(function (el) {
        el.classList.add('gs-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gs-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.gs-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Subscription Toggle --- */
  function initSubscriptionUI() {
    var container = document.querySelector('[data-gs-subscription]');
    if (!container) return;

    var rows = container.querySelectorAll('[data-gs-purchase-option]');
    var freqPanel = container.querySelector('[data-gs-frequency-panel]');
    var freqPills = container.querySelectorAll('[data-gs-frequency-pill]');
    var planInput = document.querySelector('[data-gs-selling-plan-input]');

    var firstPill = container.querySelector('.gs-hero__freq-pill--active') ||
                    container.querySelector('[data-gs-frequency-pill]');
    var defaultPlanId = firstPill ? firstPill.dataset.sellingPlanId : '';

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        rows.forEach(function (r) {
          r.classList.remove('gs-hero__po-row--active');
          r.setAttribute('aria-checked', 'false');
        });
        row.classList.add('gs-hero__po-row--active');
        row.setAttribute('aria-checked', 'true');

        var isSubscribe = row.dataset.gsPurchaseOption === 'subscribe';

        if (freqPanel) {
          freqPanel.hidden = !isSubscribe;
        }

        if (planInput) {
          planInput.value = isSubscribe ? defaultPlanId : '';
        }
      });

      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          row.click();
        }
      });
    });

    freqPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        freqPills.forEach(function (p) {
          p.classList.remove('gs-hero__freq-pill--active');
        });
        pill.classList.add('gs-hero__freq-pill--active');

        if (planInput) {
          planInput.value = pill.dataset.sellingPlanId;
        }

        defaultPlanId = pill.dataset.sellingPlanId;
      });
    });
  }

  /* --- Init on DOM ready --- */
  function init() {
    initAccordions();
    initScrollReveal();
    initSubscriptionUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
